import { api, mock } from './Api';
import { XsltTemplate } from './ApiType';
import { mockGetXsltTemplates } from './XsltsServiceMock';

const PROTECTED_BASE_PATH = '/api/xslts';

// eslint-disable-next-line import/prefer-default-export
export async function getXsltTemplates() {
  const { data } = await api.get<XsltTemplate[]>(
    `${PROTECTED_BASE_PATH}/templates`,
    {
      headers: {
        Accept: 'application/json',
      },
    },
  );
  return data;
}

mock.onGet(/\/api\/xslts\/templates$/).reply(200, mockGetXsltTemplates);
